import { Route, Routes, Outlet } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../../_metronic/layout/core'
import React, { FC, Suspense } from 'react'
import TopBarProgress from 'react-topbar-progress-indicator'
import { getCSSVariableValue } from '../../../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../../../_metronic/helpers'
import { ProductPassportMenu } from './ProductPassportMenu'
import { CreateDppWrapper } from './productions-modules/createDpp/createDpp'
import { DppList } from './productions-modules/listDpp/dppList'
import { DDPR } from '../data-administration/data-admininstration-list/DdpR/DDPR'
import { DDPR2 } from '../data-administration/data-admininstration-list/D2/DDPR2'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Product Passport',
    path: '/apps/product-passport',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ProductPassportPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route index element={<ProductPassportMenu />} />
        <Route
          path='set-up-dpp'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Set Up Dpp</PageTitle>
              {/* <CollectOrdersWrapper /> */}
              <CreateDppWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='view-dpp'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={usersBreadcrumbs}>View Dpp</PageTitle>
              {/* <ProcessingRecordList /> */}
              <DppList />
            </SuspensedView>
          }
        />
        <Route
          path='dpp-registry'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Assign DDP</PageTitle>
              {/* <ReturnOrdersWrapper /> */}
              <DDPR />
            </SuspensedView>
          }
        />
        <Route
          path='dpp-registry2'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={usersBreadcrumbs}>DDP Registry</PageTitle>
              {/* <ReturnOrdersWrapper /> */}
              <DDPR2 />
            </SuspensedView>
          }
        />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export default ProductPassportPage
